export function shouldRenderSubMenuItem(sub, ctx, can, canAny) {
  const hasPermission = sub.permission ? can(sub.permission) : true;
  const isEnabled = sub.enabled ? sub.enabled(ctx, can) : true;
  const isAnyPermissionsMatched = sub.permissions ? canAny(...sub.permissions) : true;

  return hasPermission && isEnabled && isAnyPermissionsMatched;
}
